const HTML_ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&apos;',
    '"': '&quot;',
};
class AugmentedString {
    constructor(string) {
        this.string = string;
    }
    toString() {
        return this.string;
    }
    replace(searchValue, replaceValue) {
        this.string = this.string.replace(searchValue, replaceValue);
        return this;
    }
    replaceRecursive(searchValue, replaceValue) {
        while (searchValue.test(this.string)) {
            this.string = this.string.replace(searchValue, replaceValue);
        }
        return this;
    }
    escapeHTML() {
        this.string = this.string.replace(/[&<>'"]/gu, (match) => HTML_ENTITIES[match]);
        return this;
    }
}
export default class TemplateParser {
    parse(template) {
        if (typeof template !== 'string') {
            throw new TypeError('Template must be a string');
        }
        if (template.trim() === '') {
            return [];
        }
        return new AugmentedString(template)
            .escapeHTML()
            .replace(/^ */gmu, '')
            .replace(/^---(?:\n|$)/gmu, '<hr>')
            .replace(/^ *[-*] +(.*)\n?/gmu, '<ul><li>$1</li></ul>')
            .replace(/<\/ul><ul>?/gu, '')
            .replace(/(?:^|(>?)) *\d+[.)] +(.*)\n?/gmu, '$1<ol><li>$2</li></ol>')
            .replace(/<\/ol><ol>/gu, '')
            .replace(/\n/gu, '<br>')
            .replaceRecursive(/\*([^*]+)\*/u, '<b>$1</b>')
            .replaceRecursive(/_([^_]+)_/u, '<i>$1</i>')
            .toString()
            .split(/\{([^{}]+)\}/gu);
    }
}
